import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/feature-unboxing-video';

Component('tr-feature-unboxing-video', {
  properties: {
    name: String,
    delay: {
      type: Number,
      value: 5000,
    },
    resourceType: {
      type: String,
      default: 'FeatureUnboxingVideo',
    },
    resourceId: Number,
    showGuideUrl: String,
    logUrl: String,
    abTitleAlternate: String,
    abVideoAlternate: String,
  },

  mixins: [eventListenerMixin],

  connected() {
    this.reset();
    this.listenTo(this.querySelector('.close-btn'), 'click', this.onCloseBtnClick.bind(this));

    this.listenTo(this.querySelector('.play-btn'), 'click', this.onPlayBtnClick.bind(this));
  },

  ready() {
    setTimeout(() => {
      this.slideIn();
    }, this.delay);
  },

  disconnected() {
    this.stopListening();
  },

  beforeCache() {
    this.remove();
  },

  reset() {
    this.classList.remove('slide-in');
  },

  slideIn() {
    this.addEventListener('transitionend', this.onSlideInEnd.bind(this), { once: true });
    this.classList.add('slide-in');
  },

  hide() {
    this.classList.add('hidden');
  },

  onSlideInEnd() {
    this.sendLogBehavior('show');
  },

  sendShowApi() {
    $.ajax({
      type: 'POST',
      url: this.showGuideUrl,
      dataType: 'script',
    }).catch(e => console.log(e));
  },

  onPlayBtnClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.sendShowApi();
    this.sendLogBehavior('clickplay');
    this.openVideoGuideDialog();
    this.hide();
  },

  onCloseBtnClick() {
    this.sendShowApi();
    this.sendLogBehavior('clickclose');
    this.remove();
  },

  openVideoGuideDialog() {
    let videoGuide = this.querySelector('template.video-guide-template').content.cloneNode(true);
    if (videoGuide) {
      document.body.appendChild(videoGuide);
      const videoGuideTag = 'tr-feature-video-guide';
      videoGuide = document.querySelector(videoGuideTag);
      this.listenTo(videoGuide, `${videoGuideTag}:play`, () => {
        this.sendLogBehavior('videoplay');
      });
      this.listenTo(videoGuide, `${videoGuideTag}:ended`, () => {
        this.sendLogBehavior('videoended');
      });
      this.listenTo(videoGuide, `${videoGuideTag}:closed`, (e) => {
        this.sendLogBehavior('videoclosed', e.detail);
        this.remove();
      });
    }
  },

  sendLogBehavior(action, extraValues = {}) {
    const abTest = {
      title: this.abTitleAlternate,
      video: this.abVideoAlternate,
    };
    Object.keys(abTest).forEach(key => (!abTest[key]) && delete abTest[key]);
    $.ajax({
      type: 'POST',
      url: this.logUrl,
      dataType: 'json',
      data: {
        resource_type: this.resourceType,
        resource_id: this.resourceId,
        behavior_action: `tr-feature-unboxing-video:${action}`,
        extra_values: {
          name: this.name,
          ...extraValues,
          ab_test: abTest,
        },
      },
    }).catch(e => console.error(e));
  },
});
